import { atomFamily } from "recoil"

export const multiWidgetTab = atomFamily({
    key: "dashboard.multiwidget.multiWidgetTab",
    default: "VEHICLE",
})
